import { FC } from 'react';
import { Option } from '@connect-x-app/shared-types';
import classnames from 'classnames';

import { useInputError } from '../hooks/useInputError';
import { InputWrapper, InputWrapperProps } from '../InputWrapper';

import './radioButtons.scss';

export type RadioButtonOption = Option & {
  disabled?: boolean;
};

export type RadioButtonsProps = InputWrapperProps & {
  onChange: (value: string, name: string) => void;
  options: RadioButtonOption[];
  value?: string;
};

export const RadioButtons: FC<RadioButtonsProps> = ({ onChange, options, value, ...wrapperProps }) => {
  const { disabled = false, name, validation } = wrapperProps;
  const { setDirty, showError } = useInputError(validation);

  const handleOnChange = (selectedValue: string) => {
    onChange(selectedValue, name);
    setDirty();
  };

  return (
    <InputWrapper {...wrapperProps} className={classnames('radio-buttons-wrapper', wrapperProps.className)} showError={showError}>
      <div className="radio-buttons-list">
        {options.map(option => {
          const isOptionDisabled = disabled || option.disabled;
          const isChecked = value === option.value;
          const optionId = `${name}-${option.value}`;

          return (
            <label className={classnames('radio-button-label-wrapper')} htmlFor={optionId} key={optionId}>
              <input
                checked={isChecked}
                className={classnames('radio-button-input', {
                  checked: isChecked,
                  disabled: isOptionDisabled,
                })}
                data-test={optionId}
                disabled={isOptionDisabled}
                id={optionId}
                name={name}
                onChange={() => {
                  if (!isOptionDisabled) {
                    handleOnChange(option.value);
                  }
                }}
                type="radio"
                value={option.value}
              />
              <span
                className={classnames('radio-button-label-text', {
                  disabled: isOptionDisabled,
                })}
              >
                {option.label}
              </span>
            </label>
          );
        })}
      </div>
    </InputWrapper>
  );
};
